import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("harmony_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  // Entitlement refusals carry a structured payload with a ready-written upgrade message.
  if (detail && typeof detail.message === "string") return detail.message;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function resolveUrl(url) {
  if (!url) return null;
  return url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
}

export default api;
